import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CaptainManageDetails } from 'anchor-shared/lib/model/entity/captainManageDetails';
import { Payment } from 'anchor-shared/lib/model/entity/payment';

@Component({
  selector: 'app-mark-charter-complete-modal',
  templateUrl: './mark-charter-complete.component.html',
  styleUrls: ['./mark-charter-complete.component.scss'],
})
export class MarkCharterCompleteComponent {
  captainManageDetails: CaptainManageDetails;
  depositAmount: string;
  depositPayment: Payment;
  constructor(
    public dialogRef: MatDialogRef<MarkCharterCompleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.captainManageDetails = data.captainManageDetails;
    this.depositAmount = data.depositAmount;
    this.depositPayment = data.depositPayment;
  }

  submit(shouldComplete: boolean, shouldProcessHold: boolean) {
    this.dialogRef.close({
      shouldComplete: shouldComplete,
      shouldProcessHold: shouldProcessHold,
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
